






import { Component, Vue } from 'vue-property-decorator'
import LoadingStore from '../stores/Loading'

@Component

export default class ComponentLoading extends Vue {
  get loading(): Boolean {
    return LoadingStore.getters.SHOW
  }
}
